import { Text } from "@certn/cascadia-react";
import { ActionListControl } from "@certn/forms/src/controls/ActionListControl";
import { ArrayControlProps } from "@jsonforms/core";

import { useApplication } from "../../ApplicationContext";
import { useApplicationFormContext } from "../../ApplicationFormContext";
import { updateSection, removeItems, replaceOrAddItems } from "../../utils";

export function ReferenceCheckControl(props: ArrayControlProps) {
  const { caseId } = useApplicationFormContext();
  const { currentSection, basePath } = useApplication();
  const dataSection = "reference-check-history";

  return (
    <ActionListControl
      {...props}
      renderTitle={(item) => item.referee_name}
      renderTag={() => null}
      renderSubtitle={({ email }) =>
        email ? (
          <Text style="global/body-secondary" color="text-weak">
            {email}
          </Text>
        ) : null
      }
      onItemChanged={async (data, values, index) => {
        const updatedArray = replaceOrAddItems(
          dataSection,
          data,
          values,
          index
        );
        if (caseId) {
          await updateSection(
            caseId,
            updatedArray,
            currentSection,
            false,
            basePath
          );
        }
      }}
      onItemRemoved={async (parentValues, indexes) => {
        const updatedArray = removeItems(dataSection, parentValues, indexes);
        if (updatedArray) {
          if (caseId) {
            await updateSection(
              caseId,
              updatedArray,
              currentSection,
              false,
              basePath
            );
          }
        }
      }}
    />
  );
}
